<template>
    <div class="component">
        <div class="vx-row mt-4">
            <div class="vx-col w-full">
                <div class="vx-card p-6">
                    <div class="vx-row">
                        <div class="vx-col lg:w-1/2 w-full flex items-center">
                            <span class="vs-input--label mr-2">{{ $t('wifi.branch') }}</span>
                            <v-select class="w-2/3" v-model="selectedOrganizationBranchId"
                                      :options="branchOptions" :reduce="option => option.value"
                                      @input="getEmployee"></v-select>
                        </div>
                        <div class="vx-col w-full lg:w-1/2 lg:mt-0 mt-4">
                            <div class="w-full flex font-bold">
                                <vs-button icon-pack="feather" icon="icon-chevron-left"
                                           class="lg:ml-auto ml-0 round size-button mr-2"
                                           @click="previousDate"></vs-button>
                                <span class="font-bold mt-1 mr-2">{{ $t('inputTime.week') }} {{ this.weekOfYear }}: </span>
                                <span class="mt-1 text-primary">{{
                                        this.date.startDateFormat
                                    }} - {{ this.date.endDateFormat }}</span>
                                <vs-button icon-pack="feather" icon="icon-chevron-right" class="round size-button ml-2"
                                           @click="nextDate"></vs-button>
                            </div>
                        </div>
                    </div>
                    <div class="height-table">
                        <vs-table :data="employeeList" search stripe hoverFlat noDataText="Không có dữ liệu">
                            <template slot="thead">
                                <vs-th class="border text-center bg-primary text-white"
                                       v-for="(header, index) in headers"
                                       :key="index">
                                    <div class="w-full" v-if="index != 0">
                                        <span>{{ header.title }}</span>
                                        <br/>
                                        <span>{{ header.date }}</span>
                                    </div>
                                </vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="index" v-for="(item, index) in data" :state="'success'">
                                    <vs-td class="cursor-pointer border bg-primary text-white"
                                           style="min-width:150px !important;font-size:14px">
                                        {{ item.fullName }}
                                    </vs-td>
                                    <vs-td class="cursor-pointer border text-center p-0 text-white"
                                           :style="data.date.getTime() < dateNowFormat.getTime() ? `background-color: #c7c7c7` : data.date.getTime() == dateNowFormat.getTime() ? `background-color: #D4F0FC` : null"
                                           v-for="(data, indexDate) in (arrayDate.length > 7 ? arrayDate.slice(0, 7) : arrayDate)"
                                           :key="indexDate">
                                        <div class="w-full h-full" @mouseover="updateDayOfWeeks(item, indexDate, index)"
                                             @mouseout="updateDayOfWeeks(item, indexDate, index)">
                                            <div class="w-full h-full"
                                                 v-if="item.workshifts.filter(el => el.strWorkStartAt === data.dateFormat).length > 0">
                                                <div class="w-full p-2" style="display:grid"
                                                     @click="editSchedule(workshift, data.date, item, data.dateFormat)"
                                                     v-for="(workshift, indexWorkshift) in item.workshifts.filter(el => el.strWorkStartAt === data.dateFormat)"
                                                     :key="indexWorkshift">
                                                    <span class="p-2 border-radius"
                                                          :style="data.date.getTime() < dateNowFormat.getTime() ? `background-color: #aaa; color: #fff` : `background-color:${workshift.color}; color: #fff`">
                                                        {{ workshift.organizationBranchName }}
                                                        <br/>
                                                        <span>{{ workshift.name }} ({{ workshift.startTimeFormat }} - {{
                                                                workshift.endTimeFormat
                                                            }})</span>
                                                    </span>
                                                </div>
                                                <div class="w-full">
                                                    <div class="w-full p-2 m-auto" style="display:grid">
                                                        <vx-tooltip color="primary" class="mt-1" text="Thêm ca"
                                                                    position="top">
                                                            <vs-button v-show="item.dayOfWeeks[indexDate]"
                                                                       class="w-full"
                                                                       icon-pack="feather" icon="icon-plus"
                                                                       @click="addSchedule(item, data.date, data.date)"
                                                                       v-if="data.date.getTime() >= dateNowFormat.getTime() && isPermissionAdd()"></vs-button>
                                                        </vx-tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="w-full h-full vx-col"
                                                 v-if="item.workshifts.filter(el => el.strWorkStartAt === data.dateFormat).length === 0 && data.date.getTime() >= dateNowFormat.getTime() && isPermissionAdd()"
                                                 @click="addSchedule(item, data.date, data.date)">
                                                <div class="w-full p-2 m-auto" style="height:5rem"
                                                     @click="addSchedule(item, data.date, data.date)">
                                                    <vx-tooltip color="primary" class="mt-1" text="Thêm ca"
                                                                position="top">
                                                        <vs-button v-show="item.dayOfWeeks[indexDate]"
                                                                   class="w-full mt-2"
                                                                   icon-pack="feather" icon="icon-plus"
                                                                   @click="addSchedule(item, data.date, data.date)">
                                                        </vs-button>
                                                    </vx-tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full popup-detail">
            <vs-popup :title="isUpdate ? 'Cập nhật lịch học' : 'Tạo mới lịch học'" :active.sync="activePopup">
                <div class="vx-row">
                    <!-- <div class="vx-col w-full mt-4">
                        <small class="date-label">Tên nhóm làm việc <span class="text-danger">*</span></small>
                        <vs-input v-validate="'required'" name="groupName" class="w-full"
                            v-model="workshiftByDay.groupName"></vs-input>
                        <span class="text-danger text-sm">{{ errors.first('groupName') }}</span>
                    </div> -->
                    <div class="vx-col w-full mt-4">
                        <small class="date-label">{{ $t('wifi.branch') }} <span class="text-danger">*</span></small>
                        <v-select :disabled="isUpdate" v-validate="'required'" name="organization" class="w-full"
                                  v-model="organizationBranchModel" :options="branchList"></v-select>
                        <span class="text-danger text-sm">{{ errors.first('organization') }}</span>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <small class="date-label">{{ $t('workShift.shift') }} <span class="text-danger">*</span></small>
                        <v-select v-validate="'required'" name="workshift" class="w-full"
                                  v-model="teachingScheduleModel" :options="teachingScheduleOptions"></v-select>
                        <span class="text-danger text-sm">{{ errors.first('workshift') }}</span>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <small class="date-label">{{ $t('workShift.shiftName') }}</small>
                        <vs-input :disabled="true" class="w-full" v-model="workshiftByDay.workShiftName"></vs-input>
                    </div>
                    <!-- <div class="vx-col w-full mt-4">
                        <small class="date-label">Chi nhánh <span class="text-danger">*</span></small>
                        <v-select v-validate="'required'" name="organization" class="w-full" v-model="organizationBranchModel" :options="branchList"></v-select>
                        <span class="text-danger text-sm">{{ errors.first('organization') }}</span>
                    </div> -->
                    <div class="vx-col w-full mt-4">
                        <small class="date-label">{{ $t('dashboard.employee') }}<span class="text-danger">*</span></small>
                        <v-select v-validate="'required'" name="employee" class="w-full" v-model="employeeModel"
                                  :options="employeeSelectOptions"></v-select>
                        <span class="text-danger text-sm">{{ errors.first('employee') }}</span>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <small class="date-label">{{ this.$t('workShiftByDay.workDay') }}</small>
                        <datepicker v-validate="'required'" :format="'dd/MM/yyyy'" name="startDate"
                                    v-model="workshiftByDay.startDate" :disabled="true"
                                    style="width: 100%;"></datepicker>
                        <span class="text-danger text-sm">{{ errors.first('startDate') }}</span>
                    </div>
                    <div class="vx-col w-full mt-2" v-show="workshiftByDay.startTime && workshiftByDay.endTime">
                        <div class="w-full p-4 mt-4" style="border:1px solid #ccc;border-radius:5px">
                            <div class="vx-row">
                                <div class="vx-col w-full">
                                    <div class="w-full">
                                        <small class="date-label">{{ $t('workShift.startTime') }}</small>
                                        <vs-input :disabled="true" class="w-full" type="time"
                                                  v-model="workshiftByDay.startTime"></vs-input>
                                    </div>
                                    <div class="w-full mt-1">
                                        <small class="date-label">{{ $t('workShift.endTime') }}</small>
                                        <vs-input :disabled="true" class="w-full" type="time"
                                                  v-model="workshiftByDay.endTime"></vs-input>
                                    </div>
                                </div>
                                <!-- <div class="vx-col md:w-2/12 w-full mt-8">
                                    <vs-button class="bg-danger" icon-pack="feather" icon="icon-trash" @click="removeRecord(indexWork)"></vs-button>
                                    <vs-button class="mt-4" icon-pack="feather" icon="icon-plus" @click.prevent="addRecord"></vs-button>
                                </div> -->
                            </div>
                        </div>
                    </div>

                    <!-- <div class="vx-col w-full">
                        <label class="vs-input--label"></label>
                        <vs-checkbox v-model="workshiftByDay.advanceSetting">
                            {{this.$t('workShiftByDay.settingAdvance')}}
                        </vs-checkbox>
                    </div> -->
                </div>
                <div class="vx-row" v-if="false">
                    <div class="vx-col w-full mt-4">
                        <vs-input :disabled="disabledFrom" class="w-full" :label="this.$t('workShiftByDay.flexible')"
                                  v-model="workshiftByDay.bufferTime" name="bufferTime"
                                  v-validate="'required|numeric'"/>
                        <span class="text-danger text-sm">{{ errors.first('bufferTime') }}</span>
                    </div>

                    <div class="vx-col w-full mt-4">
                        <small class="date-label">{{ this.$t('workShiftByDay.allowAdvance') }} <span
                            class="text-danger">*</span></small>
                        <vs-input class="w-full" type="time" :disabled="disabledFrom"
                                  :value="workshiftByDay.allowCheckInBefore"/>
                    </div>

                    <div class="vx-col w-full mt-4">
                        <small class="date-label">{{ this.$t('workShiftByDay.allowInlater') }} <span
                            class="text-danger">*</span></small>
                        <vs-input class="w-full" type="time" :disabled="disabledFrom"
                                  :value="workshiftByDay.allowCheckInAfter"/>
                    </div>

                    <div class="vx-col w-full mt-4">
                        <small class="date-label">{{ this.$t('workShiftByDay.allowCheckOutIn') }} <span
                            class="text-danger">*</span></small>
                        <vs-input class="w-full" type="time" :disabled="disabledFrom"
                                  :value="workshiftByDay.allowCheckOutBefore"/>
                    </div>

                    <div class="vx-col w-full mt-4">
                        <small class="date-label">{{ this.$t('workShiftByDay.allowCheckOutLater') }} <span
                            class="text-danger">*</span></small>
                        <vs-input class="w-full" type="time" :disabled="disabledFrom"
                                  :value="workshiftByDay.allowCheckOutAfter"/>
                    </div>
                </div>
                <div class="vx-row mt-4">
                    <div class="vx-col w-full flex">
                        <vs-button class="ml-auto" @click="saveChanges"
                                   v-if="checkDate >= dateNowFormat && isPermissionUpdate()"
                                   :disabled="!validateForm || workshiftByDay.currentDateFormat < dateNowFormat">{{isUpdate ? $t('button.update') : $t('button.create') }}
                        </vs-button>
                        <vs-button v-if="isUpdate && isPermissionDelete()"
                                   :class="checkDate >= dateNowFormat ? 'ml-4 bg-danger' : 'ml-auto bg-danger'"
                                   @click="removeWorkShift">{{ this.$t('button.delete') }}
                        </vs-button>
                        <vs-button v-else class="ml-4" @click="activePopup = false">{{ this.$t('button.close') }}</vs-button>
                    </div>
                </div>
            </vs-popup>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
// import StaffScheduleManager from './StaffScheduleManager.vue'
import {isAPI} from '../../../store/permission';
import {constAPI} from '../../../store/constant';

export default {
    computed: {
        organizationBranchModel: {
            get() {
                let object = this.branchList.find(el => el.value === this.workshiftByDay.organizationBranchId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            async set(object) {
                this.workshiftByDay.organizationBranchId = object ? object.value : null;
                await this.getTeachingSchedule();
            }
        },
        validateForm() {
            return !this.errors.any()
        },
        employeeModel: {
            get() {
                let object = this.employeeSelectOptions.find(el => el.value == this.workshiftByDay.employeeId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.workshiftByDay.employeeId = object ? object.value : null
            }
        },
        teachingScheduleModel: {
            get() {
                let object = this.teachingScheduleOptions.find(el => el.value == this.workshiftByDay.teachingScheduleId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value,
                    startTime: object.startTime,
                    endTime: object.endTime,
                    color: object.colorCode

                }
            },
            set(object) {
                this.workshiftByDay.teachingScheduleId = object ? object.value : null;
                this.workshiftByDay.startTime = object ? object.startTime : null;
                this.workshiftByDay.endTime = object ? object.endTime : null;
                this.workshiftByDay.color = object ? object.color : null;
                this.workshiftByDay.workShiftName = object ? object.label : null;
            }
        }
    },
    components: {
        vSelect,
        Datepicker,
        // StaffScheduleManager
    },
    data() {
        return {
            dateNowFormat: null,
            showAddSchedule: false,
            teachingScheduleOptions: [],
            disabledFrom: false,
            arrayTimeWorkshift: [{}],
            workshiftByDay: {
                organizationBranchId: null,
                employeeId: null,
                startDate: null,
                startTime: null,
                endTime: null,
                color: null,
                advanceSetting: false,
                bufferTime: 0,
                allowCheckInBefore: 0,
                allowCheckInAfter: 0,
                allowCheckOutBefore: 0,
                allowCheckOutAfter: 0
            },
            datePicker: null,
            activePopup: false,
            isUpdate: false,
            arrayDate: [],
            weekOfYear: 0,
            date: {
                startDate: null,
                endDate: null,
                startDateFormat: null,
                endDateFormat: null
            },
            employeeList: [],
            employeeOptions: [],
            employeeSelectOptions: [],
            branchList: [],
            payload: {
                organizationBranchId: null,
                enabled: true,
                fromDate: null,
                toDate: null,
                type: 0
            },
            schedule: {},
            headers: [
                {title: '', date: null}, {title: 'Thứ 2', date: null}, {title: 'Thứ 3', date: null},
                {title: 'Thứ 4', date: null}, {title: 'Thứ 5', date: null}, {title: 'Thứ 6', date: null},
                {title: 'Thứ 7', date: null}, {title: 'Chủ nhật', date: null}
            ],
            checkDate: null,
            selectedOrganizationBranchId: null,
            branchOptions: [],
        }
    },
    watch: {
        async '$store.state.isReload'(val) {
            if (val) {
                await this.getTeachingSchedule();
                this.getEmployee();
                this.$store.commit('RELOAD_DATA', false);
            }
        }
    },
    methods: {
        isPermissionAdd() {
            return isAPI(this, constAPI.schedule_staff_add)
        },
        isPermissionUpdate() {
            return isAPI(this, constAPI.schedule_staff_update)
        },
        isPermissionDelete() {
            return isAPI(this, constAPI.schedule_staff_delete)
        },
        updateDayOfWeeks(data, index, indexEmployee) {
            data.dayOfWeeks[index] = !data.dayOfWeeks[index];
            this.employeeList.splice(indexEmployee, data);
        },
        removeWorkShift() {
            this.activePopup = false;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá "${this.workshiftByDay.workShiftName}" không ?`,
                accept: this.deleteRecord,
                cancel: this.cancelRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        cancelRecord() {
            this.activePopup = true;
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post(`employee-workshift-by-day/delete/${this.workshiftByDay.id}`).then(() => {
                this.$vs.loading.close();
                this.activePopup = false;
                this.getEmployee();
                return this.$vs.notify({
                    text: 'Xoá thành công lịch dạy',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        getTeachingSchedule() {
            return new Promise((resolve, reject) => {
                const payload = {
                    type: 0,
                    organizationBranchId: this.workshiftByDay.organizationBranchId
                }
                this.$vs.loading();
                this.$crm.post('/teaching-schedule/find-all', payload).then((res) => {
                    this.teachingScheduleOptions = res.data.map(el => {
                        return {
                            label: el.name,
                            value: el.id,
                            startTime: el.startTime,
                            endTime: el.endTime,
                            color: el.colorCode
                        }
                    });
                    this.$vs.loading.close();
                    resolve(res)
                }).catch((err) => {
                    this.$vs.loading.close();
                    reject(err)
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        convertHoustToMinutes(data) {
            let strArray = data.split(':');
            return parseInt(strArray[0]) * 60 + parseInt(strArray[1])
        },
        async saveChanges() {
            // this.arrayTimeWorkshift.forEach(el => {
            //     let object = {};
            //     object['startTime'] = this.convertHoustToMinutes(el.startTime);
            //     object['endTime'] = this.convertHoustToMinutes(el.endTime);
            //     if (object.advanceSetting) {
            //         object.allowCheckInAfter = this.convertHoustToMinutes(object.allowCheckInAfter);
            //         object.allowCheckInBefore = this.convertHoustToMinutes(object.allowCheckInBefore);
            //         object.allowCheckOutAfter = this.convertHoustToMinutes(object.allowCheckOutAfter);
            //         object.allowCheckOutBefore = this.convertHoustToMinutes(object.allowCheckOutBefore);
            //     }
            //     if (this.payload.organizationBranchId) data.organizationBranchId = this.payload.organizationBranchId;
            //     payload.push({...object, ...data});
            // })
            const result = await this.$validator.validateAll();
            if (!result) return;

            // if (isNaN(this.workshiftByDay.allowCheckInAfter)) this.workshiftByDay.allowCheckInAfter = this.convertHoustToMinutes(this.workshiftByDay.allowCheckInAfter);
            // if (isNaN(this.workshiftByDay.allowCheckInBefore)) this.workshiftByDay.allowCheckInBefore = this.convertHoustToMinutes(this.workshiftByDay.allowCheckInBefore);
            // if (isNaN(this.workshiftByDay.allowCheckOutAfter)) this.workshiftByDay.allowCheckOutAfter = this.convertHoustToMinutes(this.workshiftByDay.allowCheckOutAfter);
            // if (isNaN(this.workshiftByDay.allowCheckOutBefore)) this.workshiftByDay.allowCheckOutBefore = this.convertHoustToMinutes(this.workshiftByDay.allowCheckOutBefore);
            this.workshiftByDay.groupName = this.workshiftByDay.workShiftName

            if ((this.workshiftByDay.endTime < moment(new Date()).format('HH:mm')) && (this.checkDate <= this.dateNowFormat)) {
                return this.$vs.notify({
                    text: 'Ca làm việc đã qua thời gian kết thúc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            const payload = {...this.workshiftByDay};
            if (isNaN(payload.startTime)) payload.startTime = this.convertHoustToMinutes(this.workshiftByDay.startTime);
            if (isNaN(payload.endTime)) payload.endTime = this.convertHoustToMinutes(this.workshiftByDay.endTime);
            let url = this.isUpdate ? 'employee-workshift-by-day/update' : 'employee-workshift-by-day/create'
            payload.advanceSetting = true;
            this.$vs.loading();
            this.$crm.post(url, payload).then(() => {
                this.activePopup = false;
                this.getEmployee();
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: `${this.isUpdate ? 'Cập nhật' : 'Tạo mới'} ca làm việc thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        removeRecord(index) {
            this.arrayTimeWorkshift.splice(index, 1);
        },
        addRecord() {
            this.arrayTimeWorkshift.push({});
        },
        addSchedule(data, date, dateFormat) {
            this.checkDate = dateFormat
            this.isUpdate = false;
            this.workshiftByDay = {
                teachingScheduleId: null,
                color: null,
                startDate: null,
                startTime: null,
                endTime: null,
                advanceSetting: false,
                bufferTime: 0,
                allowCheckInBefore: 60,
                allowCheckInAfter: 60,
                allowCheckOutBefore: 60,
                allowCheckOutAfter: 60,
                organizationBranchId: data.organizationBranchId,
                employeeId: data.employeeId,
                currentDateFormat: moment(date).format("DD/MM"),
                departmentType: data.departmentType
            };
            this.employeeSelectOptions = this.employeeOptions.filter(x => x.organizationBranchId == data.organizationBranchId)
            // this.getTeachingSchedule()
            this.arrayTimeWorkshift = [{}];
            this.workshiftByDay.startDate = null;
            this.workshiftByDay.workDate = null;
            this.activePopup = true;
            this.workshiftByDay.startDate = date;
            this.workshiftByDay.workDate = date;
            this.$validator.reset();
        },
        formatMinuteToHours(data) {
            let hours = Math.floor(data / 60)
            let minutes = data % 60 == 0 ? '00' : data % 60;
            return (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 && minutes > 0 ? '0' + minutes : minutes);
        },
        async editSchedule(data, date, dataEmployee, dateFormat) {
            this.checkDate = dateFormat
            this.arrayTimeWorkshift = [];
            this.workshiftByDay = {};
            this.workshiftByDay.startDate = null;
            this.activePopup = true;
            this.workshiftByDay = {
                teachingScheduleId: data.teachingScheduleId,
                workShiftName: data.workShiftName,
                id: data.id,
                groupName: data.groupName,
                color: data.color,
                startDate: data.startDate,
                startTime: data.startTimeFormat,
                endTime: data.endTimeFormat,
                advanceSetting: data.advanceSetting,
                bufferTime: data.bufferTime,
                allowCheckInBefore: data.allowCheckInBefore,
                allowCheckInAfter: data.allowCheckOutBefore,
                allowCheckOutBefore: data.allowCheckOutBefore,
                allowCheckOutAfter: data.allowCheckOutAfter,
                organizationBranchId: data.organizationBranchId,
                employeeId: data.employeeId,
                departmentType: dataEmployee.departmentType
            };
            this.employeeSelectOptions = this.employeeOptions.filter(x => x.organizationBranchId == data.organizationBranchId)
            await this.getTeachingSchedule()
            this.arrayTimeWorkshift = [{}];
            // this.workshiftByDay = data;
            this.workshiftByDay.startDate = date;
            this.workshiftByDay.workDate = date;
            this.isUpdate = true;

            //data teaching schedule
            let object = this.teachingScheduleOptions.find(el => el.value === data.teachingScheduleId);
            if (object) {
                this.workshiftByDay.teachingScheduleId = object.value;
                this.workshiftByDay.workShiftName = object.label;
                this.workshiftByDay.startTime = object.startTime;
                this.workshiftByDay.endTime = object.endTime;
            }

        },
        getNextWeek() {
            let today = moment();
            let daysToMonday = 0 - (today.isoWeekday() - 1) + 7;
            return today.subtract('days', daysToMonday);
        },
        getLastWeek() {
            let today = moment();
            let daysToLastMonday = 0 - (1 - today.isoWeekday()) + 7;
            return today.subtract('days', daysToLastMonday);
        },
        previousDate() {
            let prevStart = moment(this.date.startDate).weekday(-6);
            let prevEnd = moment(this.date.startDate).weekday(0);
            this.date.startDate = new Date(prevStart);
            this.date.endDate = new Date(prevEnd);
            this.date.startDateFormat = prevStart.format('DD/MM/YYYY');
            this.date.endDateFormat = prevEnd.format('DD/MM/YYYY');
            this.loopDateRange(false);
            this.getEmployee();
        },
        nextDate() {
            let nextStart = moment(this.date.startDate).weekday(8);
            let nextEnd = moment(this.date.startDate).weekday(14);
            this.date.startDate = new Date(nextStart);
            this.date.endDate = new Date(nextEnd);
            this.date.startDateFormat = nextStart.format('DD/MM/YYYY');
            this.date.endDateFormat = nextEnd.format('DD/MM/YYYY');
            this.loopDateRange(false);
            this.getEmployee();
        },
        getWeekNumber(d) {
            // Copy date so don't modify original
            d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            // Set to nearest Thursday: current date + 4 - current day number
            // Make Sunday's day number 7
            d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
            // Get first day of year
            let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
            // Calculate full weeks to nearest Thursday
            // Return array of year and week number
            return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
        },
        getEmployee() {
            let start = new Date(this.date.startDate.setHours(0, 0, 0));
            let end = new Date(this.date.endDate.setHours(23, 59, 59));
            this.payload.fromDate = start;
            this.payload.toDate = end;
            this.payload.organizationBranchId = this.selectedOrganizationBranchId;
            this.$vs.loading();
            this.$crm.post('/employee/find-all-schedule', this.payload).then((res) => {
                this.$vs.loading.close();
                if (res.data && res.data.length > 0) {
                    let data = res.data.filter(el => el.departmentType != 2);
                    this.employeeOptions = data.map(el => {
                        return {
                            value: el.employeeId,
                            label: el.fullName,
                            organizationBranchId: el.organizationBranchId
                        }
                    })
                    this.employeeList = data.map(el => {
                        let arrWorkshift = [];
                        let array = el.employeeWorkShiftByDays.filter(el => !el.classRoomId).map(x => {
                            let branch = this.branchList.find(branch => branch.value == x.organizationBranchId);
                            if (branch) x.organizationBranchName = branch.label;
                            x.startTimeFormat = this.formatMinuteToHours(x.startTime)
                            x.endTimeFormat = this.formatMinuteToHours(x.endTime)
                            x.strWorkEndAt = moment(new Date(x.workEndAt)).format("DD/MM");
                            x.strWorkStartAt = moment(new Date(x.workStartAt)).format("DD/MM");

                            //get name work shift
                            let name = this.teachingScheduleOptions.find(el => (el.value == x.teachingScheduleId));
                            if (name) {
                                x.name = name.label;
                                x.color = name.color;
                                x.startTimeFormat = name.startTime,
                                    x.endTimeFormat = name.endTime
                            }
                            this.arrayDate.forEach(date => {
                                if (date.dateFormat == x.strWorkStartAt) arrWorkshift.push(x);
                            })

                            return x;
                        })
                        el.workshifts = arrWorkshift;
                        el.employeeWorkShiftByDays = array;
                        el.dayOfWeeks = [false, false, false, false, false, false, false];
                        return el;
                    });
                }
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || []);
            this.branchList = branchList.filter(x => x.organizationBranchType !== 3).map(el => {
                return {
                    label: el.organizationBranchName,
                    value: el.id,
                }
            });
            this.branchOptions = branchList;
            this.branchOptions = this.branchOptions.filter(x => x.organizationBranchType !== 3).map(el => {
                return {
                    label: el.organizationBranchName,
                    value: el.id
                }
            });
            this.branchOptions.unshift({value: null, label: 'Tất cả'})
            // this.organizationBranchModel = this.branchList[0];
        },
        loopDateRange(isWeek) {
            this.arrayDate = [];
            let currentMoment = moment(this.date.startDate);
            let lastDay = isWeek ? moment(this.date.endDate) : moment(this.date.endDate).add(1, 'days');
            let index = 1;
            while (currentMoment.isBefore(lastDay)) {
                let date = new Date(currentMoment.format('MM/DD/YYYY'));
                let object = {
                    date: date,
                    dateFormat: currentMoment.format('DD/MM'),
                    workshifts: [],
                    showAddSchedule: false
                }
                this.arrayDate.push(object);
                if (this.headers[index]) {
                    this.headers[index].date = currentMoment.format('DD/MM');
                    index++;
                }
                currentMoment.add(1, 'days');
            }
            this.weekOfYear = this.getWeekNumber(this.date.startDate);
        }
    },
    async created() {
        let first = moment(new Date()).weekday(1);
        let last = moment(new Date()).weekday(7);
        this.date.startDate = new Date(first);
        this.date.endDate = new Date(last);
        this.date.startDateFormat = moment(this.date.startDate).format("DD/MM/YYYY");
        this.date.endDateFormat = moment(this.date.endDate).format("DD/MM/YYYY");
        this.loopDateRange(false);
        this.initScreen();
        await this.getTeachingSchedule();
        this.getEmployee();
        let formatDate = moment(new Date()).format('MM/DD/YYYY')
        this.dateNowFormat = new Date(formatDate);
    }
}
</script>

<style lang="scss">
.height-table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
}

.height-table .vs-con-table .vs-con-tbody {
    height: 80vh !important;
    overflow: auto;
}

.border {
    border: 1px solid #ccc
}

.size-button {
    height: 25px !important;
    width: 25px !important;
}

.vs-component .vs-popup {
    //max-width: 450px !important;
}

.border-radius {
    border-radius: 5px;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    background-color: transparent !important;
    transform: translateY(0px);
}
</style>
